export default __webpack_public_path__ + "static/media/16.d3f8b3ca.png";